'use client';

import { Button, ButtonLink } from '@/shared/ui/button';
import { StatusScreen } from '@/shared/ui/status-screen';

export default function StoreError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <StatusScreen
      eyebrow="Что-то пошло не так"
      title="Не удалось загрузить страницу"
      actions={
        <>
          <Button variant="ink" onClick={reset}>
            Повторить
          </Button>
          <ButtonLink href="/" variant="ghost">
            На главную
          </ButtonLink>
        </>
      }
    >
      <p>Сервис временно недоступен. Попробуйте обновить страницу через минуту.</p>
    </StatusScreen>
  );
}
